import { memo } from "react";

import { useTranslation } from 'react-i18next';
const shimmerClass =
  "relative overflow-hidden before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_2s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/10 before:to-transparent";

function SkeletonBlock({ className = "" }) {
    const { t } = useTranslation();
return (
    <div
      className={`bg-zinc-800/60 rounded ${shimmerClass} ${className}`}
    />
  );
}

/**
 * SkeletonCard — placeholder card for blog posts, marketplace agents, etc.
 * Matches the dark theme with shimmer animation.
 */
const SkeletonCard = memo(function SkeletonCard({ featured = false }) {
  return (
    <div
      className={`border border-zinc-800 bg-zinc-950/30 overflow-hidden animate-pulse ${
        featured ? "sm:col-span-2" : ""
      }`}
    >
      {/* Image placeholder */}
      <SkeletonBlock
        className={`w-full ${featured ? "h-48 sm:h-64" : "h-40"}`}
      />

      <div className="p-4 sm:p-6">
        {/* Category tag placeholder */}
        <SkeletonBlock className="h-4 w-20 mb-3" />

        {/* Title placeholder */}
        <SkeletonBlock
          className={`mb-3 ${featured ? "h-6 w-3/4" : "h-5 w-2/3"}`}
        />

        {/* Text lines placeholder */}
        <SkeletonBlock className="h-4 w-full mb-2" />
        <SkeletonBlock className="h-4 w-5/6 mb-2" />
        {!featured && <SkeletonBlock className="h-4 w-4/6 mb-4" />}

        {/* Button placeholder */}
        <SkeletonBlock className="h-9 w-28" />
      </div>
    </div>
  );
});

export default SkeletonCard;
